import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import * as ObjectActions from './actions';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import * as AppActions from '../app/actions';
import { IotDeviceManagementPortalAppState } from '../iotDeviceManagementPortalApp.reducer';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private store: Store<IotDeviceManagementPortalAppState>,
  ) {}

  private USER_URLS = {
    GET: {
      UPDATE_CURRENT_USER: '/api/updatecurrentuser',
    },
  };


  @Effect()
  fetchError$ = this.actions$.pipe(
    ofType(ObjectActions.FETCH_ERROR),
    map(() => {
      return new AppActions.HideLoader();
    }),
  );
}
